import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types';
import { InformationState } from './types';

export const getIndividu: Getter<InformationState, RootState> = state => state.individu;
export const getParents: Getter<InformationState, RootState> = state => state.parents || [];
export const getMedecin: Getter<InformationState, RootState> = state => state.medecin;
export const getMaladies: Getter<InformationState, RootState> = state => state.maladies || [];
export const getAutorisations: Getter<InformationState, RootState> = state => state.autorisations || [];
export const getAllergies: Getter<InformationState, RootState> = state => state.allergies || [];
export const getVaccins: Getter<InformationState, RootState> = state => state.vaccins || [];
export const getFamilleChamps: Getter<InformationState, RootState> = state => state.famille_champs || [];
export const getIndividuChamps: Getter<InformationState, RootState> = state => state.individu_champs || [];
export const getChampsLibres: Getter<InformationState, RootState> = state => state.champs_libres || [];
export const getChampLibreValeur: Getter<InformationState, RootState> = state => state.champs_libres_valeurs || [];
export const getChampLibreResultValeur: Getter<InformationState, RootState> = state => state.Champs_libres_results_valeurs || [];
export const getInformationIndividu: Getter<InformationState, RootState> = state => state.information_individu || [];
export const getDossier: Getter<InformationState, RootState> = state => state.dossier || [];



export const getters: GetterTree<InformationState, RootState> = {
  getIndividu,
  getParents,
  getMedecin,
  getMaladies,
  getAutorisations,
  getAllergies,
  getVaccins,
  getFamilleChamps,
  getIndividuChamps,
  getChampsLibres,
  getChampLibreValeur,
  getChampLibreResultValeur,
  getInformationIndividu,
  getDossier
}